<template>
  <base-section
    id="blockchain"
    max-width="1024"
    class="mx-auto"
  >
    <v-container>
      <base-subheading
        title="Why Blockchain?"
        tag="h1"
        space="12"
      />

      <!--      <base-img-->
      <!--        :height="$vuetify.breakpoint.mdAndUp ? 500 : 250"-->
      <!--        :src="require(`@/assets/project-${Math.floor(Math.random() * 10)}.jpg`)"-->
      <!--        class="mb-6 mb-md-12"-->
      <!--      />-->

      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <base-title title="The Killer Token... Finally!!!" />

          <base-body space="12">
            The HEQ token was purpose built with one thing in mind;  "Real" Stability!
            <br><br>

            *brain storm
            ** Gold Standard
            ** Make sure to express - the first thing of real value that you own... Gold has no value, but your home truly does.  It has substance.
            *** Don't pit us against fiat/dollar
            ****

            Building a Stablecoin that offers "Real" liquidity and stability is not easy.  When we embarked on this journey, we realized that
            there is only one asset that exists that could ever truly support true Stability - Real Estate.  However,
            Real Estate alone could not solve this problem.  Many have made promises about tokenizing property, fractional ownership and
            even liquidity.  But all have failed to realize that to bring "Real" liquidity, technology must detach from the concept of ownership and instead
            realize Real Estate could become to core of "Real" value.  It is the most secure product ever created that does not simply disappear or lose value when the wind blows.
            Real Estate is at the core of everything each and everyone of us is concerned about.  So why then has Real Estate not become the
            de-facto of all currency?
            <br><br>
            Introducing the HEQ Token - The only currency backed by the entire Real Estate market.  The most reliable and only Real Estate backed debt securitized Stablecoin ever created.
            <br><br>
            At its core it is simple to understand.  We looked at blockchain at its most basic and powerful function.  A simple, pure, digital currency - each and every piece of Real Estate that is
            brought into the HEQ blockchain, represents a fraction of value derived from the overall value of all pooled equity.  You do not own a fraction of property,
            instead you own a piece of the entire Real Estate market (How does that feel?).  What other asset in existence could ever match the power of this asset?
            None... Introducing  HEQ, the digital currency, backed by each and every piece of Real Estate that is introduced into the HEQ Blockchain

            <br><br>
            A currency built to withstand the fiercest of economic conditions.
            <br><br>
            A crypto currency with true liquidity, backed by Real Assets, with Real Value bringing Real Stability.
            <br><br>
            Look no further, your assets are no longer backed by imaginary paper...

            Pooling:
          </base-body>

          <v-row class="text-center">
            <v-col
              v-for="[value, title] of values"
              :key="title"
              cols="6"
              md="3"
            >
              <base-circular-progress v-bind="{ title, value }" />
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <!--          <div class="mb-12">-->
          <!--            <base-title-->
          <!--              align="center"-->
          <!--              title="SHARE"-->
          <!--            />-->

          <!--            <div class="mx-n2 text-center">-->
          <!--              <v-icon-->
          <!--                v-for="icon in icons"-->
          <!--                :key="icon"-->
          <!--                class="px-2"-->
          <!--                @click="() => {}"-->
          <!--                v-text="icon"-->
          <!--              />-->
          <!--            </div>-->
          <!--          </div>-->

          <!--          <div class="caption">-->
          <!--            <base-title-->
          <!--              title="GENERAL INFO"-->
          <!--              space="2"-->
          <!--            />-->

          <!--            <v-divider />-->

          <!--            <div class="grey&#45;&#45;text text&#45;&#45;darken-1">-->
          <!--              <template v-for="([title, sub], i) of info">-->
          <!--                <v-row-->
          <!--                  :key="title"-->
          <!--                  class="mx-0 my-3"-->
          <!--                  justify="space-between"-->
          <!--                >-->
          <!--                  <span v-text="title" />-->

          <!--                  <strong v-text="sub" />-->
          <!--                </v-row>-->

          <!--                <v-divider :key="`divider-${i}`" />-->
          <!--              </template>-->
          <!--            </div>-->
          <!--          </div>-->
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Blockchain',

    data: () => ({
      icons: [
        'mdi-twitter',
        'mdi-facebook',
        'mdi-github',
        'mdi-snapchat',
      ],
      info: [
        ['LIVE SITE', 'ZERO-THEME-PRO.JOHNLEIDER.COM'],
        ['DEVELOPMENT TIME', '2 MONTHS'],
        ['TRAFFIC INCREASE', 'BY 91%'],
        ['CUSTOMER SATISFACTION', '99%'],
      ],
      values: [
        [100, 'Stability'],
        [100, 'Security'],
        [100, 'Performance'],
        [100, 'Value'],
      ],
    }),
  }
</script>
